import React, { Component } from 'react';
import './Footer.css';

import Config from '../../../base/config/Config';

import Logo from '../../../resources/images/fullLogo.png';
import l2020 from '../../../resources/images/2020.png';
import Button from '../button/Button';
import Title from '../title/Title';
import NetworkLogo from '../networkLogo/NetworkLogo';
import SmallText from '../smallText/SmallText';

class Footer extends Component {
    render() {
        return <div className="Footer">
        <div className="WidthLimit">
        <div className="Column-D1 NoMargin">
        <img src={Logo} alt="Swonkie Full Logo" />
        </div>
        <br /><br />
        <div className="Column-D1 NoMargin">
        <div className="Column-D2 NoMargin">
        <Title text="Swonkie Lda" size="Small" color="Light" type="Normal" /><br /><br />
        <SmallText text={<span>{Config.contactAddress}<br />{Config.contactLocation}</span>} />
        <br /><br /><SmallText text={Config.contactEmail} />
        </div>
        <div className="Column-D2 NoMargin">
        <div className="Column-D2 NoMargin">
        <Button text="Features" type="Clean Discreet" weight="Thin" to={Config.mainHost + "#features"} /><br />
        <Button text="Pricing" type="Clean Discreet" weight="Thin" to={Config.mainHost + "prices"} /><br />
        <Button text="Careers" type="Clean Discreet" weight="Thin" to={Config.mainHost + "job"} /><br />
        <Button text="Blog" type="Clean Discreet" weight="Thin" to={Config.mainHost + "blog"} /><br />
        <Button text="API" type="Clean Discreet" weight="Thin" to="/documentation" />
        </div>
        <div className="Column-D2 NoMargin">
        <Button text="Terms & Conditions" type="Clean Discreet" weight="Thin" to={Config.mainHost + "terms&conditions"} /><br />
        <Button text="Privacy Policy" type="Clean Discreet" weight="Thin" to={Config.mainHost + "privacy"} /><br />
        <Button text="2020 Support" type="Clean Discreet" weight="Thin" to={Config.mainHost + "2020"} />
        </div>
        </div>
        </div>
        <div className="Spacer"></div>
        <div className="Column-D1 NoMargin">
        <div className="Column-D2 NoMargin">
        <img src={l2020} alt="2020 Logo" />
        </div>
        <div className="Column-D2 NoMargin" style={{textAlign:"right"}}>
        <SmallText text={<font>Swonkie © {(new Date()).getFullYear()} All Rights Reserved</font>} />
        <NetworkLogo network="Facebook" size="Medium" />
        <NetworkLogo network="Instagram" size="Medium" />
        <NetworkLogo network="Twitter" size="Medium" />
        <NetworkLogo network="LinkedIn" size="Medium" />
        </div>
        </div>
        <div className="Spacer"></div>
        </div>
        </div>;
    }
}

export default Footer;